module.exports = __webpack_public_path__ + "static/media/Illus-Delivery_1@2x.ca674e6f.png";